module.exports = __webpack_public_path__ + "static/media/2020.6.23端午节包粽子活动.4a784226.jpg";